import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private storage$: Storage | null = null;

  constructor(private storage: Storage) { }

  async init() {
    const storage = await this.storage.create();
    this.storage$ = storage;
    console.log('Storage initialized');
  }

  public set(key: string, value: any) {
    if (this.storage$) {
      this.storage$.set(key, value);
    }
  }

  public get(key: string) {
    if (this.storage$) {
      return this.storage$.get(key);
    }
    return Promise.resolve(null);
  }

  // public addToList(key: string, value: any) {
  //   if (this.storage$) {
  //     this.storage$.get(key).then(list => {
  //       if (list) {
  //         list.push(value);
  //         this.storage$.set(key, list.slice(500));
  //       } else {
  //         this.storage$.set(key, [value]);
  //       }
  //     });
  //   }
  // }

}
